import { useHotelStore } from "@/shared/stores/hotel-store/HotelStoreProvider";
import type { MinPriceRoom } from "@/types/services/hotel/apis/Detail";

export default function useCountRooms(room: MinPriceRoom, limit: number) {
  const { rate_plans, id } = room;
  const { rooms, setDetailRooms } = useHotelStore((state) => state);
  const totalRoomCount = rooms.reduce((total, curr) => total + curr.count, 0);
  const currentRoomIndex = rooms.findIndex(
    (room) => room.id === id && room.rate_plans.id === rate_plans.id,
  );
  const currentRoomCount = rooms[currentRoomIndex]?.count ?? 0;

  const countRooms = (count: number) => {
    const isAddition = count > currentRoomCount && totalRoomCount < limit;
    const roomExistInRooms = currentRoomIndex !== -1;

    setDetailRooms(
      isAddition
        ? // For Addition - If room doesn't exist in rooms array add it otherwise increase it's count number
          !roomExistInRooms
          ? [...rooms, { ...room, count }]
          : rooms.map((room) =>
              room.id === id && room.rate_plans.id === rate_plans.id
                ? { ...room, count }
                : room,
            )
        : // For Subtraction - If room exist in rooms array and it's count is 1 remove it otherwise decrease it's count number
          currentRoomCount === 1
          ? [
              ...rooms.slice(0, currentRoomIndex),
              ...rooms.slice(currentRoomIndex + 1),
            ]
          : rooms.map((room) =>
              room.id === id && room.rate_plans.id === rate_plans.id
                ? { ...room, count }
                : room,
            ),
    );
  };

  return { countRooms, currentRoomCount, totalRoomCount };
}
